import {TBaseAnimationPayload} from "../types";

export const DEFAULT_ANIMATION_PAYLOAD: TBaseAnimationPayload = {duration: 0.33, timingFunction: 'ease'};
